export default function Products() {
  return (
    <section id="products" className="py-32 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex flex-col items-center mb-20">
          <div className="text-sm text-gray-600 uppercase tracking-wider mb-6 flex flex-col items-center gap-1">
            <span>EURIPUS</span>
            <span>d.o.o.</span>
          </div>
          <h2 className="text-6xl font-serif text-gray-900 text-center font-medium">
            Our Product Portfolio
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-10" data-product-shop>
          <div className="bg-black rounded-3xl p-12 flex flex-col justify-between min-h-[400px]">
            <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mb-8">
              <span className="text-white text-3xl font-bold">V</span>
            </div>
            <div>
              <h3 className="text-white text-3xl font-bold mb-4 leading-tight">
                SECURE VPN CONNECTION
              </h3>
              <p className="text-gray-400 text-sm">
                Military-grade encryption for your privacy
              </p>
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden min-h-[400px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/425e0f62c06bc6ad657cc7466a924577.jpg" 
              alt="VPN Security Feature"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute top-6 left-6">
              <div className="bg-black/40 backdrop-blur-sm rounded-xl px-4 py-2 flex items-center gap-2">
                <i className="ri-shield-check-line text-white text-base"></i>
                <span className="text-white text-xs uppercase tracking-wider">SECURITY</span>
              </div>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-3xl font-bold leading-tight">
                Advanced Protection Technology
              </h3>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-12 flex flex-col justify-between min-h-[400px]">
            <div>
              <h3 className="text-gray-900 text-4xl font-serif font-medium mb-3 leading-tight">
                DEVICE OPTIMIZATION
              </h3>
              <p className="text-gray-600 text-sm mb-8">
                Free up space and boost performance
              </p>
            </div>
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img 
                src="https://readdy.ai/api/search-image?query=iOS%20Cleaner%20application%20interface%20showing%20storage%20optimization%20dashboard%20with%20colorful%20charts%20and%20file%20categories%2C%20bright%20modern%20mobile%20app%20design%20with%20clean%20white%20background%2C%20iPhone%20screen%20displaying%20storage%20analysis%20with%20circular%20progress%20indicators%20and%20cleanup%20suggestions%2C%20professional%20product%20photography%20with%20soft%20lighting%2C%20minimalist%20UI%20featuring%20storage%20breakdown%20by%20file%20types%20with%20vibrant%20accent%20colors&width=400&height=300&seq=prod2&orientation=landscape" 
                alt="Cleaner Interface"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
